import axios from 'axios';

export default function submitDisputes({ requestCollection }) {
  return axios.post(`api/beacon/ShortageDisputeSubmission`, requestCollection);
}
